<template>
    <div class="carousel">
        <img @click="prev" :src="arrowLeft" class="arrow left" alt="Previous" />
        <div class="carousel-images">
            <img
                v-for="(image, index) in images"
                :key="index"
                :src="image"
                alt="Carousel Image"
                :class="{
                    'current-image': index === currentIndex,
                    'hidden-image': index !== currentIndex
                }"
                :style="{
                    zIndex: index === currentIndex ? 5 : index,
                    left: index === currentIndex ? 0 : `${(5 - index) * 20}px`, // Position images
                    top: index === currentIndex ? 0 : `${(5 - index) * 10}px`, // Position images vertically
                    transform: `rotate(${index === currentIndex ? 0 : 5 - index}deg)`,
                    height: index === currentIndex ? '100%' : `${100 - (5 - index) * 5}%`
                }"
            />
        </div>
        <img @click="next" :src="arrowRight" class="arrow right" alt="Next" />
    </div>
</template>

<script>
    import arrowLeft from './../../../images/exploration/arrow-left.svg'
    import arrowRight from './../../../images/exploration/arrow-right.svg'

    export default {
        props: {
            images: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                currentIndex: 0,
                arrowLeft,
                arrowRight
            }
        },
        methods: {
            prev() {
                this.currentIndex =
                    (this.currentIndex - 1 + this.images.length) % this.images.length
            },
            next() {
                this.currentIndex = (this.currentIndex + 1) % this.images.length
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';

    .carousel {
        display: flex;
        align-items: center;

        .carousel-images {
            position: relative;
            margin: 0 20px;
            width: 270px;
            height: 270px;
            overflow: visible;

            img {
                position: absolute; /* Stack images on top of each other */
                top: 0;
                height: 100%;
                width: auto; /* Maintain aspect ratio */
                transition: left 0.5s ease, transform 0.5s ease, height 0.5s ease; /* Smooth transitions */
            }
        }

        .arrow {
            background: none;
            border: none;
            cursor: pointer;
            width: 16px;
            height: 16px;
            display: flex;
            z-index: 6;
        }
    }
</style>
